import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const PATPAYMENTCONFIRMATIONPAGE_LEGACY_FIELD_ORDER = [
  { type: 'separator' },
  'background_image',
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  patPaymentConfirmationPageDescriptor: _generatedPatPaymentConfirmationPageDescriptor,
  patPaymentConfirmationPageBlocDefinition,
  patPaymentConfirmationPageDashboardLayout,
  patPaymentConfirmationPageConfig,
  patPaymentConfirmationPageResolveConfig,
  patPaymentConfirmationPageProperties,
} = doodBlockConfig(
  {
    name: "Pay at table - Payment confirmation",
    internal_name: "Pay at table - Payment confirmation",
    url: "payment-confirmation/:id",
    defaultParent: [/^Main Layout$/i],
    componentType: 'PatPaymentConfirmationPageComponent',
    category: 'pay_at_table',
    description: "Pay at table - Payment confirmation.",
    keywords: [],
    isRootBlock: true,
    sharedFields: {}
,
    slots: [
      {
        key: 'body',
        name: "pages.blocks.pat-payment-confirmation-page.body.label",
        accept: 'explicitOnly',
        allowedTypes: [".*(?<!Page)"],
        slotItemFormat: 'ids',
      }
    ],
  },

  () => ({
    background_image: propertyValue({
      type: 'image',
      value: '',
      options: {
        label: "pages.blocks.generic-page.background-image.label",
        help: "pages.blocks.generic-page.background-image.help",
      }
    }),
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.pat-payment-confirmation-page.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.generic-page.fieldset.appearance.label",
            fields: ["background_image"],
          },
          {
            legend: "pages.blocks.pat-payment-confirmation-page.fieldset.blocks.label",
            fields: ["body"],
          },
        ],
      },
    ],
  })
);

export function patPaymentConfirmationPageDescriptor(): IBlockDescriptor;
export function patPaymentConfirmationPageDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function patPaymentConfirmationPageDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedPatPaymentConfirmationPageDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedPatPaymentConfirmationPageDescriptor, patPaymentConfirmationPageProperties, fieldOrder);
}

export {
  patPaymentConfirmationPageBlocDefinition,
  patPaymentConfirmationPageDashboardLayout,
  patPaymentConfirmationPageProperties,
  patPaymentConfirmationPageConfig,
  patPaymentConfirmationPageResolveConfig,
};

export type PatPaymentConfirmationPageConfig = typeof patPaymentConfirmationPageConfig;
